import styled from "styled-components";

export const Container = styled.div``;

export const HeaderSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 1rem;
`;
export const HeaderText = styled.h4`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin: 0;
`;

export const InfoSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	margin-top: 1rem;
`;

export const InfoText = styled.h4`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin: 0;
`;
